import { AfterViewInit, Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { environment } from '@env/environment';

declare var window: any;
declare var grecaptcha: any;

/**
 * Form "Yêu cầu hỗ trợ khôi phục tài khoản" — dành cho user mất cả mật khẩu lẫn thiết bị 2FA
 * (không còn mã khôi phục). Gửi yêu cầu để admin xác minh danh tính ngoài hệ thống rồi duyệt.
 */
@Component({
  selector: 'app-recovery-request',
  templateUrl: './recovery-request.component.html',
  styleUrls: ['./recovery-request.component.scss']
})
export class RecoveryRequestComponent implements AfterViewInit {
  bgLoginPath = environment.bgLogin;
  logoPath = environment.logo;
  form: FormGroup;
  isSubmitted = false;
  isLoading = false;
  submitted = false;
  captchaToken: string | null = null;

  private readonly api = `${environment.backend.sso}/v1/user/recovery-request`;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private toastr: ToastrService
  ) {
    this.form = this.fb.group({
      loginName: [null, Validators.required],
      contactEmail: [null, [Validators.required, Validators.email]],
      reason: [null]
    });
  }

  ngAfterViewInit(): void {
    window.onCaptchaResolved = (token: string) => {
      this.captchaToken = token;
    };
    const interval = setInterval(() => {
      if (window.grecaptcha) {
        clearInterval(interval);
        grecaptcha.render('recaptcha-recovery', {
          sitekey: environment.siteKeyCaptcha,
          callback: (token: string) => {
            this.captchaToken = token;
          }
        });
      }
    }, 300);
  }

  get f() {
    return this.form.controls;
  }

  submit(): void {
    this.isSubmitted = true;
    if (this.form.invalid) return;
    if (!this.captchaToken) {
      this.toastr.error('Vui lòng xác thực captcha');
      return;
    }
    this.isLoading = true;
    const body = { ...this.form.value, captcha: this.captchaToken };
    this.http.post<any>(this.api, body).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res?.code === 'SUCCESS') {
          this.submitted = true;
        } else {
          this.toastr.error(res?.message);
        }
      },
      error: (err) => {
        this.isLoading = false;
        this.toastr.error(err?.error?.message || 'Đã có lỗi xảy ra. Vui lòng thử lại sau!');
      }
    });
  }

  backToLogin(): void {
    this.router.navigate(['/login']).then();
  }
}
